module.exports = __webpack_public_path__ + "static/img/30-1.420942a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/30-1.jpg
// module id = Y3dQ
// module chunks = 0